<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
import { toRaw, watchEffect } from 'vue';
import { useQuery } from '@tanstack/vue-query';

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';
import BaseCheckBox from '../common/BaseCheckBox.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useProductStore } from '@/store/product.store';

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  errorMessage,
  file,
  form_product_step_one,
  previewUrl,
  arraysStepOne,
  category_product,
  stepOneActive,
  stepTwoActive,
  descriptionPageProduct,
  arraysStepTwo,
  stepThreeActive,
  sateIncrement,
  arraysStepThree,
  dynamicOptions,
} from '@/refs/product.refs';
import { IconUploadCloud } from '@/assets/svg/common.svg';
import { useCategoryStore } from '@/store/category.store';
import BaseIncAndDecreMentBtn from '../common/BaseIncAndDecreMentBtn.vue';
import { rules_promotion } from '@/refs/promotion.refs';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const productStore = useProductStore();
const categoryStore = useCategoryStore();

// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------

// -------------------------------
// 🔹 Toutes les fonctions
// -------------------------------

// -------------------------------
// 🔹 Debugging (optionnel)
// -------------------------------
// watchEffect(() => {
//     console.log("Valeurs cochées :", productStore.datagetProduct);
// });

const HandleCheckedDesignation = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'firstField';
  const index = arraysStepThree.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepThree.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepThree.value[index] = newItem;
    } else {
      arraysStepThree.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepTwo.value));
};

const goToNextPage = () => {
  descriptionPageProduct.value =
    'Produit / Nouveau produit / Informations du produit / Ajouter des accompagnements/Ajouter des options';
  stepOneActive.value = false;
  stepTwoActive.value = false;
  stepThreeActive.value = true;
};

const HandleInscrement = () => {
  rules_promotion.value.push({
    type: '',
    operator: '',
    value: '',
  });
  //   sateIncrement.value = sateIncrement.value + 1;
};

const HandleDecreInscrement = (index?: number) => {
  if (rules_promotion.value.length <= 1) return;
  rules_promotion.value.splice(index, 1);
};
const handleSubmit = () => {
  console.log('Valeurs enregistrées :', toRaw(rules_promotion.value));
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="w-full space-y-8">
      <div
        class="flex w-full flex-row items-start gap-4"
        v-for="(_sateIncrement, index) in rules_promotion"
        :key="index"
      >
        <h1>{{ index + 1 }}</h1>
        <div class="w-full space-y-6">
          <div class="flex flex-col gap-2">
            <label
              for="taxe"
              class="text-14px font-tt-medium-Normal leading-normal"
            >
              Veuillez sélectionner le type de règle
              <span class="text-decroissance text-14px leading-normal">*</span>
            </label>

            <select
              required
              id="taxe"
              name="taxe"
              v-model="_sateIncrement.type"
              class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
            >
              <option value="" selected>Choisissez un type de règle</option>
              <option value="product_in_cart">produit dans le panier</option>
              <option value="category_in_cart">catégorie dans le panier</option>
              <option value="cart_total">total du panier</option>
              <option value="customer_group">groupe de clients</option>
              <option value="customer_tag">étiquette client</option>
              <option value="day_of_week">jour de la semaine</option>
              <option value="quantity_threshold">seuil de quantité</option>
              <option value="time_of_day">heure de la journée</option>
              <option value="payment_method">mode de paiement</option>
            </select>
          </div>

          <div class="flex flex-col gap-2">
            <label
              for="taxe"
              class="text-14px font-tt-medium-Normal leading-normal"
            >
              Veuillez sélectionner un opérateur
              <span class="text-decroissance text-14px leading-normal">*</span>
            </label>

            <select
              required
              id="taxe"
              name="taxe"
              v-model="_sateIncrement.operator"
              class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
            >
              <option value="" selected>Choisissez un type d'opérateur</option>
              <option value="equals">égal à</option>
              <option value="not_equa">pas égal à</option>
              <option value="greater_than">plus grand que</option>
              <option value="less_than">moins que</option>
              <option value="contains">contient</option>
              <option value="in">dans</option>
              <option value="not_in">pas dans</option>
            </select>
          </div>

          <TextInput
            @HandleTextInput="(e: Event) => HandleCheckedDesignation(e)"
            required="true"
            v-model="_sateIncrement.value"
            name="Valeur de la règle"
            placeholder="Valeur de la promotion"
            type="text"
            id="Valeur de la promotion"
            :label="`Valeur de la promotion `"
            class="flex-1"
          />
        </div>
        <BaseIncAndDecreMentBtn
          @HandleDecreInscrement="() => HandleDecreInscrement(index)"
          :sateIncrement="index + 1"
          @HandleInscrement="() => HandleInscrement()"
        />
      </div>
    </div>
  </form>
</template>
